import AuthorizationBackground from './AuthorizationBackground';

export default AuthorizationBackground;
